export var GetAnimationHistoryFromSessionStorage = function (arrayLength, key) {
    var showUnlockAnimationHistory = [];
    try {
        if (sessionStorage)
            showUnlockAnimationHistory = JSON.parse("".concat(sessionStorage === null || sessionStorage === void 0 ? void 0 : sessionStorage.getItem(key)));
    }
    catch (err) {
        showUnlockAnimationHistory = [];
    }
    return showUnlockAnimationHistory === null
        ? new Array(arrayLength).fill(true)
        : showUnlockAnimationHistory;
};
